import type { CleaningPhotoResponse, DamageReportResponse } from '@/shared/api';
import { ReportCard } from './ReportCard';

interface Props {
  taskId: string;
  reports: DamageReportResponse[];
  photos: CleaningPhotoResponse[];
  canWork: boolean;
  canAcknowledge: boolean;
  emptyLabel: string;
  onAcknowledge: (reportId: string) => void;
  onCapture: (reportId: string, file: File) => void;
  onRetake: (photoId: string) => void;
  attachingReportId?: string;
  retakingPhotoId?: string;
}

/** Liste der Meldungen eines Reiters; ordnet jeder Meldung ihre `damageReportId`-Fotos zu. */
export function ReportList({
  taskId,
  reports,
  photos,
  canWork,
  canAcknowledge,
  emptyLabel,
  onAcknowledge,
  onCapture,
  onRetake,
  attachingReportId,
  retakingPhotoId,
}: Props) {
  if (reports.length === 0) {
    return <p className="text-ink-soft text-sm">{emptyLabel}</p>;
  }
  return (
    <ul className="space-y-2">
      {reports.map((report) => (
        <ReportCard
          key={report.id}
          taskId={taskId}
          report={report}
          photos={photos.filter((p) => p.damageReportId === report.id)}
          canWork={canWork}
          canAcknowledge={canAcknowledge}
          onAcknowledge={onAcknowledge}
          onCapture={onCapture}
          onRetake={onRetake}
          attachingReportId={attachingReportId}
          retakingPhotoId={retakingPhotoId}
        />
      ))}
    </ul>
  );
}
